import React, { useState } from "react";
import "./index.scss";
import { VT, MT, WT } from "../../../helpers/constants/circuitCodes";
import { TopRankingsProps, RankDetails } from "./types";
import { ImageUrl } from "../../../helpers/types";
import { Carousel } from "../../Carousel/Carousel";
import Dropdown from "../../../static/Dropdown/Dropdown";
import { dropdownItem } from "../../../static/Dropdown/types";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { omitNation } from "../../../helpers";

interface TopRankingProps {
  rankDetails: RankDetails;
}

const TopRanking = (props: TopRankingProps) => {
  const {
    rankDetails: {
      rank,
      rankMovement,
      playerFamilyName,
      playerGivenName,
      playerProfileLink,
      playerNationalityCode,
      profilePictureUrls,
      hiddenPlayer
    }
  } = props;
  let rankClass = "";
  if (rankMovement && rankMovement > 0) {
    rankClass = "positive";
  } else if (rankMovement && rankMovement < 0) {
    rankClass = "negative";
  }
  const profileImg = profilePictureUrls.filter((imgUrl: ImageUrl) => {
    return imgUrl.cropKey === "Large";
  });

  return (
    <div
      className={`top-player-rankings ${
        hiddenPlayer ? "top-player-rankings--hidden" : ""
        }`}
    >
      <div className="top-player-rankings__img-container">
        <a href={!hiddenPlayer ? playerProfileLink : undefined}>
          <span className="top-player-rankings__main-ranking">{rank}</span>
          <img
            src={profileImg[0].imageUrl}
            alt={`${playerGivenName} ${playerFamilyName} profile picture`}
          />
        </a>
      </div>
      <div className="top-player-rankings__details-container">
        <div className="top-player-rankings__player-details">
          <p>
            <span>{playerGivenName}</span>
            {playerFamilyName.toLowerCase()}
          </p>
          <div className="itf-flag-container">
            <span className={`itf-flags itf-flags--${playerNationalityCode}`} />
            <span className="top-player-rankings__nationality">
              {omitNation(playerNationalityCode)}
            </span>
          </div>
        </div>
        <div className="top-player-rankings__ranking">
          {rankMovement !== 0 ? (
            <span className={rankClass}>{rankMovement}</span>
          ) : (
              <span className={rankClass} />
            )}
          {!hiddenPlayer ? (
            <a className="more-link" href={playerProfileLink}>
              View profile
            </a>
          ) : (
              <span>&nbsp;</span>
            )}
        </div>
      </div>
    </div>
  );
};

interface Rankings {
  rankDetails: RankDetails[];
  seeAllLink?: string;
  seeAllText?: string;
  page: number;
  itemsPerPage: number; // e.g. 3 on desktop, 2 on tablet, 1 on mobile
}

const TopRankingList = (props: Rankings) => {
  const { rankDetails, page, itemsPerPage } = props;
  const slicedRankings = rankDetails.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );

  return (
    <>
      <ReactCSSTransitionGroup
        transitionName="carousel__animation"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
        className="carousel__animation-container"
      >
        {slicedRankings.map(item => {
          return (
            <TopRanking
              key={`${item.playerId}${item.rank}`}
              rankDetails={item}
            />
          );
        })}
      </ReactCSSTransitionGroup>
    </>
  );
};

const TopRankings = (props: TopRankingsProps) => {
  const itemsToDisplay = { DESKTOPXL: 5, DESKTOP: 5, TABLET: 4, MOBILE: 2 };
  const [selectedTab, setSelectedTab] = useState(0);
  let dropdownItems: dropdownItem[] = [];

  props.rankings.map((ranking, key) => {
    dropdownItems.push({
      label:
        ranking.circuitCode == VT
          ? `${ranking.playerType} ${parseInt(
            (ranking.ageCategoryDesc || "").split(" ")[1]
          )}+`
          : ranking.circuitCode == MT || ranking.circuitCode == WT
            ? ranking.matchType
            : ranking.playerType,
      value: key
    });
  });

  const dropdownProps = {
    options: dropdownItems,
    placeholder: "Singles",
    defaultValue: dropdownItems[0],
    onChange: (value: dropdownItem) => {
      setSelectedTab(value.value as number);
    }
  };

  return (
    <div className="top-rankings-section">
      <h2>{props.title}</h2>
      <Dropdown {...dropdownProps} />
      <Carousel totalItems={10} itemsToDisplay={itemsToDisplay}>
        <TopRankingList
          rankDetails={props.rankings[selectedTab].rankDetails}
          page={0}
          itemsPerPage={itemsToDisplay["DESKTOP"]}
        />
      </Carousel>
      <div className="center-content">
        <a href={props.rankings[selectedTab].rankingsLink} className="btn">
          See all rankings
        </a>
      </div>
    </div>
  );
};

export default TopRankings;
